module.exports = __webpack_public_path__ + "static/media/shape0_3.6f76ff2b.obj";